import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { UserService } from '../../services/user.service';
import { TourService } from '../../services/tour.service';

@Component({
  selector: 'app-utility-nav',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './utility-nav.component.html',
  styleUrl: './utility-nav.component.scss'
})
export class UtilityNavComponent {
  private router = inject(Router);
  private userService = inject(UserService);
  unreadNews = this.userService.select('unreadNews');
  unreadMessages = this.userService.select('unreadMessages');

  private tourService = inject(TourService);
  readonly tourMenu = this.tourService.tourMenu.asReadonly();
  
  public onTour() {
    this.tourService.startTour(this.router.url);
  }
}
